const getApiBaseUrl = () => {
  const { origin } = window.location;
  const API_URL = origin.concat('/backend/api');
  if (origin.includes('local')) return 'https://localhost:5001/api';
  return API_URL;
};

export const API_BASE_URL = getApiBaseUrl();
